export default "__VITE_ASSET__BXFJ_QZa__"